<template>
  <v-card class="modal-copiar-cotacao">
    <v-toolbar height="56" color="primary" dark flat>
      <v-toolbar-title>Copiar Cotação</v-toolbar-title>
    </v-toolbar>

    <v-card-text class="pa-4">
      <p class="mb-3">Escolha como deseja copiar a cotação:</p>

      <v-radio-group v-model="tipoCopia" hide-details class="mt-0">
        <v-radio
          color="primary"
          label="Copiar cotação completa"
          value="COMPLETA"
        ></v-radio>
        <v-radio
          color="primary"
          label="Copiar informações gerais e importar nova planilha de itens"
          value="PARCIAL"
        ></v-radio>
      </v-radio-group>

      <p v-if="tipoCopia === 'PARCIAL'" class="mt-3 texto-auxiliar">
        Os itens da cotação original não serão copiados. A importação da nova
        planilha será feita na tela de veículos.
      </p>
    </v-card-text>

    <v-card-actions class="pa-3">
      <v-spacer></v-spacer>
      <v-btn flat color="primary" @click="cancelar">CANCELAR</v-btn>
      <v-btn color="primary" @click="confirmar">PROSSEGUIR</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "ModalCopiarCotacao",

  data() {
    return {
      tipoCopia: "COMPLETA"
    };
  },

  methods: {
    confirmar() {
      this.$emit("confirmar", { copiaParcial: this.tipoCopia === "PARCIAL" });
    },

    cancelar() {
      this.$emit("cancelar");
    }
  }
};
</script>

<style scoped>
.modal-copiar-cotacao {
  background: #f2f2f2;
}
.texto-auxiliar {
  font-size: 13px;
  color: rgba(0, 0, 0, 0.6);
}
</style>



// WEBPACK FOOTER //
// src/components/pages/frota/ModalCopiarCotacao.vue